import { Modal, Button } from "react-bootstrap";

// const Heading = ({ children }) => (
//     <h5 style={{ color: 'rgb(0, 0, 0)', marginBottom: '10px' }}>{children}</h5>
// );

const Paragraph = ({ children }) => (
  <p style={{ color: "rgb(41, 41, 41)", marginBottom: "10px" }}>{children}</p>
);

const ListItem = ({ children }) => (
  <li style={{ color: "rgb(41, 41, 41)", marginBottom: "10px" }}>{children}</li>
);

const BoldText = ({ children }) => (
  <b style={{ color: "rgb(0, 0, 0)" }}>{children}</b>
);

function WithdrawConfirmationModal({
  show,
  onClose,
  withdrawAmtRequested,
  currency,
  method,
  withdrawAddress,
  isSubmitting,
}) {
  const handleYes = () => onClose(true);
  const handleNo = () => onClose(false);
  const numericAmount =
    Number(String(withdrawAmtRequested || "").replace(/,/g, "")) || 0;
  const formattedAmount = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount);
  const currencyLabel =
    currency?.toLowerCase() === "cad"
      ? "Canadian dollars (CAD)"
      : currency?.toUpperCase();
  const methodLabel =
    method?.toLowerCase() === "interac" ? "Interac e-Transfer" : method;

  return (
    <Modal
      show={show}
      onHide={() => !isSubmitting && onClose(false)}
      backdrop={isSubmitting ? "static" : true}
      keyboard={!isSubmitting}
    >
      <Modal.Header closeButton={!isSubmitting}>
        <Modal.Title style={{ color: "black" }}>
          Withdraw Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Paragraph>
          By clicking 'Confirm', the transaction will be submitted for Interac
          e-Transfer to the address below. The transaction will be{" "}
          <BoldText>FINAL</BoldText> once completed and cannot be cancelled.
        </Paragraph>
        <Paragraph>
          Please make sure that the following information is correct:
        </Paragraph>
        <ul>
          <ListItem>
            Recipient Address: <BoldText>{withdrawAddress}</BoldText>
          </ListItem>
          <ListItem>
            Amount: <BoldText>{formattedAmount}</BoldText>
          </ListItem>
          <ListItem>
            Currency: <BoldText>{currencyLabel}</BoldText>
          </ListItem>
          <ListItem>
            Payment Method: <BoldText>{methodLabel}</BoldText>
          </ListItem>
        </ul>

        <Paragraph>
          Or you can click on 'Cancel' to cancel the transaction and review the
          information.
        </Paragraph>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleNo} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={handleYes}
          disabled={isSubmitting}
          aria-busy={isSubmitting}
        >
          {isSubmitting && (
            <span
              className="spinner-border spinner-border-sm me-2"
              aria-hidden="true"
            ></span>
          )}
          {isSubmitting ? "Submitting..." : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default WithdrawConfirmationModal;
